export const utilityBarConsts = {
  SEARCH_FIELD_NAME: "searchField",
  SEARCH_PLACEHOLDER: "Search",
  SEARCH_ICON_ALT: "Click to search",
  SHOW_BLOCKED: "Show blocked",
  BLOCK_TOGGLE_NAME: "showBlockedToggle",
};
